module.exports = __webpack_public_path__ + "static/media/hallauer_riviero_gibson.cc977369.jpg";